import { get } from 'lodash'
import { required, requiredCheck } from 'utils/validation'

export default values => {
  return {
    note: required(get(values, 'note')),
    helpers: {
      requirements: requiredCheck(get(values, 'helpers.requirements'))
    }
  }
}
